import {
  CreateLandingSubscriptionOverloadDocument,
  CreateLandingSubscriptionOverloadMutation,
  GetEnabledModulesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'

const DEFAULT_PLAN = 'core_b-area_a'
const DEFAULT_EXPIRATION_DAYS = 14

interface CreateSubscriptionParams {
  chargebeeId: string
  overloadReason: string
  newExpirationDate: string
}

const useCreateSubscriptionOverload = (companyIds: string[]) => {
  const { data: subscriptionsOverloadData } = useQuery(GetEnabledModulesDocument, {
    variables: { companyIds },
  })

  const [mutate] = useMutation(CreateLandingSubscriptionOverloadDocument, {
    extractorFn: (data: CreateLandingSubscriptionOverloadMutation) =>
      data.companiesMutations.createCompaniesSubscriptionOverload,
  })

  const createSubscription = (params: CreateSubscriptionParams) => {
    const { chargebeeId, overloadReason, newExpirationDate } = params
    const subscriptionOverload =
      subscriptionsOverloadData?.companies.subscriptionOverloadsConnection.nodes[0]

    const today = new Date()
    today.setDate(today.getDate() + DEFAULT_EXPIRATION_DAYS)

    const planId = subscriptionOverload?.planId || DEFAULT_PLAN
    const existingExpirationDate =
      subscriptionOverload?.expirationDate || today.toISOString().split('T')[0] || ''
    // Normalize to YYYY-MM-DD format (ISO8601Date) for consistent comparison and mutation
    const normalizedNewExpirationDate = newExpirationDate.split('T')[0] || ''
    const expirationDate =
      normalizedNewExpirationDate > existingExpirationDate
        ? normalizedNewExpirationDate
        : existingExpirationDate
    const addonIds = subscriptionOverload?.addonIds || []
    const addonsUpdated = Array.from(new Set([...addonIds, chargebeeId]))

    return mutate({
      variables: {
        addonIds: addonsUpdated,
        expirationDate: expirationDate || '',
        overloadReason: overloadReason,
        planId: planId,
        source: 'landing_page',
      },
    })
  }

  return createSubscription
}

export default useCreateSubscriptionOverload
